import { h } from 'preact';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import styles from '../global.css';
import { RpmDivider } from './_common.js';
import LazyDifferenceCard from '../differenceCard/lazyDifferenceCard.jsx';

export default function LazyRpmGoodExperience(_props) {
  return (
    <Card sx={{ marginBottom: '20px' }}>
      <CardActions>
        <Typography variant="h5">
          <Skeleton width={240} />
        </Typography>

        <Box sx={{ marginLeft: 'auto' }}>
          <LazyDifferenceCard />
        </Box>

        {RpmDivider}
        <LazyDifferenceCard />
        {RpmDivider}
        <LazyDifferenceCard />
        {RpmDivider}

        <Skeleton width={360} height={48} />

        <Skeleton width={40} height={40} variant="circular" />
      </CardActions>
      <CardContent className={styles.goodUxHolder}>
        <Skeleton width="100%" height={360} variant="rounded" />
      </CardContent>
      <CardActions>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography>Other Metrics</Typography>
          <Skeleton width={58} height={38} variant="rounded" />
          <Typography>CWV</Typography>
        </Stack>
      </CardActions>
    </Card>
  );
}
